import { toZonedTime } from "date-fns-tz";
import { View } from "@src/components";
import { useUnistyles } from "react-native-unistyles";
import { FC, memo } from "react";

interface CurrentTimeIndicatorProps {
  timezone: string;
  barHeight: number;
}

const DOT_SIZE = 8;

export const CurrentTimeIndicator: FC<CurrentTimeIndicatorProps> = memo(({ timezone, barHeight }) => {
  const { theme } = useUnistyles();
  const now = toZonedTime(new Date(), timezone);
  const nowY = ((now.getHours() + now.getMinutes() / 60) / 24) * barHeight;
  const lineColor = theme.colors.text as string;

  return (
    <>
      {/* Dot */}
      <View
        style={{
          position: "absolute",
          top: nowY - DOT_SIZE / 2,
          left: -DOT_SIZE / 2,
          width: DOT_SIZE,
          height: DOT_SIZE,
          borderRadius: DOT_SIZE / 2,
          backgroundColor: lineColor,
          zIndex: 6,
        }}
      />
      {/* Horizontal line */}
      <View
        style={{
          position: "absolute",
          top: nowY - 0.75,
          left: 0,
          right: 0,
          height: 1.5,
          backgroundColor: lineColor,
          zIndex: 5,
        }}
      />
    </>
  );
});
